/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedModelEntityModelTimestampDto } from '../models/PagedModelEntityModelTimestampDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class TimestampControllerService {

  /**
   * Returns a paged list of Safe entities
   * @returns PagedModelEntityModelTimestampDto Paged list of file timestamp values
   * @throws ApiError
   */
  public static getFileTs({
authorization,
}: {
authorization?: string,
}): CancelablePromise<PagedModelEntityModelTimestampDto> {
    return __request(OpenAPI, {
      method: 'GET',
      url: '/api/timestamp',
      headers: {
        'Authorization': authorization,
      },
      errors: {
        403: `Unauthorized user`,
      },
    });
  }

}
